export const isVideoLink = (url: string) => {
	const videoExtensionsRegex = /\.(mp4|webm|ogg|avi|mov|wmv|flv|mkv|m4v|3gp|m2ts|ts|mts|vob|rmvb|mpg|mpeg)$/i;
	return videoExtensionsRegex.test(url);
};
